import { useEffect, useState } from "react";
import queryString from 'query-string';
import history from "../../history";
import moment from "moment";
import { DATE_FORMAT } from "../../constants";
import resmiRuhsatBasvuruSayilari from "../../services/resmiRuhsatBasvuruSayilari";
import belgeTuruVeDurumunaGoreResmiBasvuruListesi from "../../services/belgeTuruVeDurumunaGoreResmiBasvuruListesi";
import useColumns from "../../hooks/useColumns";
import { Table, Card, Row, Col, Drawer, Modal, Spin, Input, Space, Button, Tooltip as TooltipAnd } from 'antd';
import { UnorderedListOutlined, SearchOutlined, OrderedListOutlined ,FileExcelOutlined} from '@ant-design/icons'
import { Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis } from "recharts";
import ExcelExport from './../ExcelExport';
import basvuruStateZamanlariList from "../../services/basvuruStateZamanlariLists";

const parsed = queryString.parse(history.location.search);

const ResmiRuhsatRapor = () =>{

    const [dates, setDates] = useState([moment(), moment()]);
    const [resmiRuhsatBasvurus, setResmiRuhsatBasvurus] = useState([]);
    const [totalCountbasvurular, setTotalCountbasvurular] = useState(0);
    const [visible, setVisible] = useState(false);
    const [queryDates, setQueryDates] = useState([undefined, undefined]);
    const [basvurular, setBasvurular] = useState([]);
    const {resmiBasvuruColumns,basvuruSurecGecmisColumns} = useColumns();
    const belgeGrubuId = parsed.belgeGrubuId.split(',').map(item=> { return parseInt(item)});
    const [spining, setSpining] = useState(false);
    const [filtredBasvurular, setFiltredBasvurular] = useState([]);
    const [basvuruStateList, setBasvuruStateList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const resmiBasvuruColumnsWithIslem = [...resmiBasvuruColumns];
    resmiBasvuruColumnsWithIslem.push({
      title: 'İşlem',
      key: 'key',
      dataIndex: 'key',
      width: 80,
      fixed: 'right',
      render: (text, record) => (
        <TooltipAnd title="Süreç Geçmişi Görüntüle">
          <Button type="primary" onClick={() => { openModalBasvuruStateList(record.objectid, record.altSurecTipiId) }} shape="circle" icon={<OrderedListOutlined />} />
        </TooltipAnd>
      ),
    })

    useEffect(()=> {
        resmiRuhsatBasvuruSayilari(belgeGrubuId)
        .then(res=>{
            setResmiRuhsatBasvurus(res.data.result);
        });
        setQueryDates(dates);
    },[]);

    const getBelgeTuruVeDurumunaGoreResmiBasvuruListesi = (belgeGrubuId, belgeTuruId, basvuruAnaDurumId) => {
      setSpining(true);
        belgeTuruVeDurumunaGoreResmiBasvuruListesi(belgeGrubuId, belgeTuruId, basvuruAnaDurumId)
          .then(res => {
            setBasvurular(res.data.result);
            setTotalCountbasvurular(res.data.result.length);
            setSpining(false);
          })
          .catch(ex=> {
            setSpining(false);
          })
      }
const openModalBasvuruStateList = (basvuruId, altSurecTipiId) => {

    let filterModel = {};

    if (basvuruId !== undefined && basvuruId != null) {
      filterModel.basvuruId = basvuruId;
    }
    if (altSurecTipiId !== undefined && altSurecTipiId != null) {
      filterModel.altSurecTipiId = altSurecTipiId;
    }
    setSpining(true);
    basvuruStateZamanlariList(filterModel)
    .then(res => { console.log("Başarılı"); setBasvuruStateList(res.data.result); setSpining(false); showModal(); })
    .catch(ex => { setSpining(false);});

  };

  const showModal = () => {

    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
    const columns = [
        {
          title: 'Belge Türü',
          dataIndex: 'belgeTuruAdi',
          key: 'belgeTuruAdi',
          render: (_, record) => <div className="list-div-cell">
            <span>{record.belgeTuruAdi}</span>
          </div>
        },
        {
          title: 'Aktif Başvuru Sayısı',
          dataIndex: 'aktif',
          key: 'aktif',
          render: (_, record) => <div className="list-div-cell">
            <span>{record.aktif}</span>
            <UnorderedListOutlined onClick={() => {
              setVisible(true);
              getBelgeTuruVeDurumunaGoreResmiBasvuruListesi(belgeGrubuId, record.belgeTuruId, record.aktifId);
            }} />
          </div>
        },
        {
          title: 'Tamamlanan Başvuru Sayısı',
          dataIndex: 'tamamlandi',
          key: 'tamamlandi',
          render: (_, record) => <div className="list-div-cell">
            <span>{record.tamamlandi}</span>
            <UnorderedListOutlined onClick={() => {
              setVisible(true);
              getBelgeTuruVeDurumunaGoreResmiBasvuruListesi(belgeGrubuId, record.belgeTuruId, record.tamamlandiId);
            }} />
          </div>
        },
        {
          title: 'Toplam Başvuru Sayısı',
          render: (_, record) => <div className="list-div-cell">
            <span>{record.tamamlandi + record.aktif}</span>
            <UnorderedListOutlined onClick={() => {
              setVisible(true);
              getBelgeTuruVeDurumunaGoreResmiBasvuruListesi(belgeGrubuId, record.belgeTuruId);
            }} />
          </div>
        }
      ];
    
      let opKeyTitles = resmiBasvuruColumns.map(items => { return { key: items.key, title: items.title } });
    
      return <Spin tip={"Veriler Yükleniyor"} spinning={spining} > <Card
        style={{ margin: "20px" }}
        title={<h2 style={{ fontWeight: "bolder", color: "white" }}>Belge Türlerine Göre Resmi Ruhsat Başvuru Sayıları</h2>}
        className="ant-card-head-title-large"
      >
        <Row gutter={16}>
          <Col className="gutter-row" xs={24} sm={24} md={24} lg={12} xl={12}>
            <BarChart width={730} height={250} data={resmiRuhsatBasvurus} >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="belgeTuruAdi" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="aktif" fill="#0000ff" style={{ cursor: "pointer" }} onClick={(record) => {
                setVisible(true);
                getBelgeTuruVeDurumunaGoreResmiBasvuruListesi(belgeGrubuId, record.belgeTuruId, record.aktifId);
    
              }} />
              <Bar dataKey="tamamlandi" fill="#00ee00" style={{ cursor: "pointer" }} onClick={(record) => {
                setVisible(true);
                getBelgeTuruVeDurumunaGoreResmiBasvuruListesi(belgeGrubuId, record.belgeTuruId, record.tamamlandiId);
    
              }} />
              <Legend wrapperStyle={{ position: 'relative', marginTop: '5px' }} />
            </BarChart>
          </Col>
          <Col className="gutter-row" xs={24} sm={24} md={24} lg={12} xl={12}>
            <Table bordered dataSource={resmiRuhsatBasvurus} columns={columns} pagination={false}
              pagination={{
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
                total: resmiRuhsatBasvurus && resmiRuhsatBasvurus.length,
                showTotal: (total) => <div>{"Toplam: " + total}</div>
              }}
              summary={pageData => {
                let totalAktif = 0;
                let totalTamamlandi = 0;
                let aktifId = pageData.aktifId;
                let tamamlandiId = pageData.tamamlandiId;
                let belgeTuruId = pageData.belgeTuruId;
    
    
                pageData.forEach(({ aktif, tamamlandi, belgeTuruId }) => {
                  totalAktif += aktif;
                  totalTamamlandi += tamamlandi;
                  aktifId = pageData[0].aktifId;
                  tamamlandiId = pageData[0].tamamlandiId;
                  belgeTuruId = pageData[0].belgeTuruId;
                });
    
                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell style={{ fontWeight: 'bold' }}>Toplam Başvuru Sayısı</Table.Summary.Cell>
                      <Table.Summary.Cell className="list-div-cell">
                        {totalAktif}
                        <UnorderedListOutlined onClick={() => {
                          setVisible(true);
                          getBelgeTuruVeDurumunaGoreResmiBasvuruListesi(belgeGrubuId, belgeTuruId, aktifId);
                        }} />
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="">
                        <div class="list-div-cell">
                          {totalTamamlandi}
                          <UnorderedListOutlined onClick={() => {
                            setVisible(true);
                            getBelgeTuruVeDurumunaGoreResmiBasvuruListesi(belgeGrubuId, belgeTuruId, tamamlandiId);
                          }} />
                        </div>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className='list-div-cell'>
                        {totalAktif + totalTamamlandi}
                        <UnorderedListOutlined onClick={() => {
                          setVisible(true);
                          getBelgeTuruVeDurumunaGoreResmiBasvuruListesi(belgeGrubuId);
                        }} />
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              }}
            />
          </Col>
        </Row>
        <Row gutter={16}>
          {visible &&
            <Card style={{ marginTop: "8px", width: "100%" }}
              title={<h4 style={{ fontWeight: "bolder", color: "white" }}>Resmi Başvuru Bilgileri</h4>}
              className="ant-card-head-title-medium">
              <Table scroll={{ x: 1500, y: 500 }}  rowKey={"objectid"} bordered dataSource={basvurular} columns={resmiBasvuruColumnsWithIslem}
                title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h3 style={{ fontWeight: "bolder" }}>{''}</h3>
                  <ExcelExport
                    fileName={'Başvuru Bilgileri ' + " - " + queryDates[0]?.format(DATE_FORMAT) + "-" + queryDates[1]?.format(DATE_FORMAT)}
                    downloadButton={<Button type="link" icon={<FileExcelOutlined style={{ color: "green" }} />} />}
                    sheets={[{ data: basvurular, name: 'Test', keyTitles: opKeyTitles }]} />
                </div>}
                onChange={
                  (pagination, filters, sorter, extra) => {
                    if (extra.currentDataSource.length < basvurular.length) {
                      setTotalCountbasvurular(extra.currentDataSource.length);
                    }
                    else {
                      setFiltredBasvurular(basvurular);
                      setTotalCountbasvurular(basvurular.length);
                    }
                  }
                }
                pagination={{
                  showSizeChanger: true,
                  pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
                  total: totalCountbasvurular && totalCountbasvurular,
                  showTotal: (total) => <div>{"Toplam: " + total}</div>
                }}
              />
               <Modal title="Başvuru Geçmişi" centered visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
            <Table rowKey={"stateId"} bordered dataSource={basvuruStateList} columns={basvuruSurecGecmisColumns}
              pagination={{
                showSizeChanger: true,
                pageSize:5,
                pageSizeOptions: ['5', '10', '20', '30', '40', '50', '100'],
                total: basvuruStateList && basvuruStateList.length,
                showTotal: (total) => <div>{"Toplam: " + total}</div>
              }} 
            />
          </Modal>
            </Card>
          }
        </Row>
        {
    
        }
      </Card>
      </Spin>

}

export default ResmiRuhsatRapor;